<template>
	<ul class="list">
		<li v-for="language in availableLanguages" :class="{'item--current': $store.state.currentFormLanguage === language.code}"
			@click="changeLanguage(language.code)" class="item">
			<img class="item__flag" :src="language.flag" alt=""> {{ language.label }}
		</li>
	</ul>
</template>
<script>
	export default {
		data () {
			return {
				availableLanguages: [
					{flag: '/static/Poland.png', code: 'pl', label: 'Polski'},
					{flag: '/static/England.png', code: 'en', label: 'Angielski'},
				]
			}
		},
		methods: {
			changeLanguage (language) {
				this.$store.commit('setCurrentFormLanguage', language)
			}
		}
	}
</script>
<style lang="scss" scoped>
	.list {
		list-style-type: none;
		padding: 0;
		margin: 0;
	}

	.item {
		display: inline-block;
		cursor: pointer;
		padding: 7px 14px;
		background: #f3f3f3;
		&__flag {
			vertical-align: middle;
		}
		&--current {
			background: #19aa8d;
			color: #ffffff;
		}
	}
</style>



// WEBPACK FOOTER //
// FormLanguageSwitcher.vue?67f20ff6